import { render } from "./BmotikBrand.vue?vue&type=template&id=7106935e&scoped=true"
import script from "./BmotikBrand.vue?vue&type=script&lang=js"
export * from "./BmotikBrand.vue?vue&type=script&lang=js"

import "./BmotikBrand.vue?vue&type=style&index=0&id=7106935e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7106935e"]])

export default __exports__